import { Component, Prop, Ref, SimpleEvent, Watch } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { debounce } from 'lodash';

@Component
export class QuantitySpinner extends ThemeComponent {
    @Prop({default: 1}) min!: number;
    @Prop({default: 9999}) max!: number;
    @Prop({attr: 'value'}) value!: number;

    @Ref() decreaseButton!: HTMLButtonElement;
    @Ref() increaseButton!: HTMLButtonElement;
    @Ref() input!: HTMLInputElement;

    protected rendering!: number;
    private _onChange = new SimpleEvent<number>();
    get onChange() {
        return this._onChange.asEvent();
    }

    public updateQuantity(quantity:number) {
        this.updateValue(quantity);
    }

    init() {
        this.$log.info('initing');
        this.$listen(this.increaseButton, 'click', () => this.increment());
        this.$listen(this.decreaseButton, 'click', () => this.decrement());
        this.render();
    }

    @Watch('rendering')
    private render() {
        const initialValue = this.input.value;
        this.input.value = (Math.min(this.max, Math.max(this.min, this.value))).toString();
        if (initialValue !== this.input.value) {
            this._onChange.dispatch(parseInt(this.input.value, 10));
        }
    }

    public updateValue(value: number) {
        this.value = value;
        this.input.value = String(value);
        this.rendering = this.value;

        if (this.value == 1) {
            this.decreaseButton.disabled = true;
        }

        if (this.value > 1) {
            this.decreaseButton.disabled = false;
        }

    }

    public increment() {
        this.value++;
        this.rendering = this.value;
        if (this.value > 1) {
            this.decreaseButton.disabled = false;
        }
        if ((this.value + 1) > this.max) {
            this.increaseButton.disabled = true;
            return;
        }
    }

    public decrement() {
        this.increaseButton.disabled = false;
        this.value--;
        this.rendering = this.value;
        if (this.value == 1) {
            this.decreaseButton.disabled = true;
        }
    }
}
